import { render, staticRenderFns } from "./AgentUserMessage.vue?vue&type=template&id=a27979f6&scoped=true&"
import script from "./AgentUserMessage.vue?vue&type=script&lang=js&"
export * from "./AgentUserMessage.vue?vue&type=script&lang=js&"
import style0 from "./AgentUserMessage.vue?vue&type=style&index=0&id=a27979f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27979f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
